import React, {
	Component
} from "react";
import {
	View,
	StyleSheet
} from "react-native";

import xtend from "xtend";
import memoize from "memoizee";

import Style from "ae-style";

import FormInput from "./FormInput";
import InputLabel from "./Layout/InputLabel";
import InputContainer from "./Layout/InputContainer";

var styles = StyleSheet.create({
	inputs: {
		flexDirection: "row"
	},
	hours: {
		flex: 1,
	},
	minutes: {
		flex: 1,
		marginLeft: Style.layout.marginSmall
	}
});

export default class Time extends Component {
	constructor(props){
		super(props);

		this.state = {
			hasChanged: false,
			time: {
				minutes: 0,
				hours: 0,
			}
		};

		this.update = memoize(updateTime.bind(this));
	}

	render(){
		var props = this.props;
		var state = this.state;
		var schema = props.schema;
		var defaultValue = props.defaultValue;

		var properties = schema.properties || {};
		var hourSchema = properties.hours;
		var minuteSchema = properties.minutes;

		var hasChanged = state.hasChanged;
		var renderedValue = hasChanged ? state.time : (defaultValue || state.time);

		if(!hourSchema || !minuteSchema) return null;

		var update = this.update;

		var errors = props.errors || [];
		var hourErrors = errors.filter(function(error){
			return error.field[0] === "hours";
		});
		var minutesErrors = errors.filter(function(error){
			return error.field[0] === "minutes";
		});

		return (
			<InputContainer inline={props.inline}>
				<InputLabel schema={schema} />
				<View style={styles.inputs}>
					<View style={styles.hours}>
						<FormInput
							unsupportedFeatures={props.unsupportedFeatures}
							platform={props.platform}
							id={this.props.id + "_hours"}
							inline
							schema={hourSchema}
							defaultValue={renderedValue.hours}
							onChange={update("hours")}
							errors={hourErrors}
							showCustomAddButton = {props.showCustomAddButton}
						/>
					</View>
					<View style={styles.minutes}>
						<FormInput
							unsupportedFeatures={props.unsupportedFeatures}
							platform={props.platform}
							id={this.props.id + "_minutes"}
							inline schema={minuteSchema}
							defaultValue={renderedValue.minutes}
							onChange={update("minutes")}
							errors={minutesErrors}
							showCustomAddButton = {props.showCustomAddButton}
						/>
					</View>
				</View>
			</InputContainer>
		);
	}
}

function updateTime(property) {
	var component = this;
	return function(value){
		var state = component.state;
		var props = component.props;

		var update = {};
		update[property] = value;

		var existing = state.hasChanged ? state.time : (props.defaultValue || state.time);

		var changed = xtend(existing, update);
		component.setState({
			hasChanged: true,
			time: changed
		});

		var onChange = props.onChange;
		if(onChange) onChange(changed);
	};
}
